<template>
  <div class="bar-chart-container">
    <div class="title-bar">各乡镇产量</div>
    <div class="chart-box" ref="barChartRef"></div>
  </div>
</template>

<script>
import PartTitle from './PartTitle.vue';

export default {
  name: 'BarChart',
  components: { PartTitle },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  watch:{
    items: {
      handler(val) {
        if (val.length > 0) {
          this.mapData = val;
          this.initChart();
        }
      },
      deep: true
    }
  },
  data() {
    return {
      chartInstance: null,
      option: {
        mapData: [],
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          // formatter: function (params, ticket, callback) {
          //   debugger;
          // },
        },
        legend: {
          textStyle: { color: '#ffffff' },
        },
        xAxis: {
          type: 'value',
          // name: '百万根',
          axisLabel: {
            fontSize: 12,
            color: '#ffffff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ffffff',
            },
          },
        },
        yAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            fontSize: 12,
            color: '#ffffff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ffffff',
            },
          },
        },
        series: [
          {
            name: '竹材产量(吨)',
            type: 'bar',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: '#bad9e5', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#02fff7', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              borderRadius: [0, 20, 20, 0],
            },
            data: [],
          },
          {
            name: '竹笋产量(吨)',
            type: 'bar',
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0.3,
                    color: '#0087ff', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#6894ff', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              borderRadius: [0, 20, 20, 0],
            },
            data: [],
          },
        ],
      },
    };
  },
  created() {
  },
  mounted() {

  },
  methods: {
    initChart() {
      let chartRef = this.$refs.barChartRef;
      if (this.chartInstance) {
        this.chartInstance.dispose(); // 销毁已有实例
      }
      this.chartInstance = this.$echarts.init(chartRef);
      this.resolveMapData(this.mapData)
      if(this.option) {
        this.chartInstance.setOption(this.option, true);
      }
    },
/**
     * 处理mapData
     */
     resolveMapData(mapData) {
      const yAxisData = mapData.map((v) => v.title);
      this.option.yAxis.data = yAxisData.slice(0,5);
      mapData.forEach((item) => {
        yAxisData.forEach((townText) => {
          if (item.title === townText) {
            // 竹材产量
            const zhucai = item.data.find((x) => x.title === '竹材产量');
            this.option.series[0].data.push(zhucai.data);
            // 竹笋产量
            const zhusun = item.data.find((x) => x.title === '竹笋产量');
            this.option.series[1].data.push(zhusun.data);
          }
        });
      });

    },

  },
};
</script>

<style lang="scss" scoped>
.bar-chart-container {
  flex: 1;
  .title-bar {
    width: 94%;
    height: 40px;
    background-color: rgba(0, 63, 152, 0.4);
    margin: 0 auto;
    line-height: 40px;
    color: #ffffff;
    font-size: 15px;
    border-radius: 4px;
    padding-left: 20px;
    box-sizing: border-box;
  }
  .chart-box {
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
